import { render, staticRenderFns } from "./PersonalAccountPage.vue?vue&type=template&id=2b7c1bc4&scoped=true&"
import script from "./PersonalAccountPage.vue?vue&type=script&lang=js&"
export * from "./PersonalAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c1bc4",
  null
  
)

export default component.exports